import { render } from "./CustomButton.vue?vue&type=template&id=7c513f54&scoped=true"
import script from "./CustomButton.vue?vue&type=script&lang=js"
export * from "./CustomButton.vue?vue&type=script&lang=js"

import "./CustomButton.vue?vue&type=style&index=0&id=7c513f54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c513f54"]])

export default __exports__